// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"f14709be","977":"a211e7ae"}[chunkId] + ".chunk.js";
};